"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShapeToBorderRadiusAlias = useShapeToBorderRadiusAlias;
var _react = require("react");
function useShapeToBorderRadiusAlias(shape) {
  return (0, _react.useMemo)(() => {
    switch (shape) {
      case 'circle':
        return 'roundedFull';
      case 'squircle':
        return 'rounded';
      case 'square':
        return 'roundedSmall';
      default:
        return undefined;
    }
  }, [shape]);
}